import Icon from '../components/Icon.vue'

Icon.register({
  tint: {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M205.2 22.1C197.3-6.7 155.8-8 146.8 22.1 100 179.9 0 222.7 0 333.9 0 432.4 78.7 512 176 512S352 432.4 352 333.9C352 222.2 252.2 180.6 205.2 22.1zM176 448C114.3 448 64 397.8 64 336 64 327.2 71.2 320 80 320S96 327.2 96 336C96 380.1 131.9 416 176 416 184.8 416 192 423.2 192 432S184.8 448 176 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tint.js
// module id = jsY1
// module chunks = 144